<template>
  <div class="pd-10">
    <b-overlay :show="!resObj.loaded" rounded="sm">
      <ul class="activity tx-13">
        <li class="activity-item" v-for="(l, i) in resObj.list" :key="i">
          <div
            class="activity-icon"
            :class="
              l.flag == 0
                ? 'bg-warning-light tx-danger'
                : 'bg-primary-light tx-primary'
            "
          >
            {{ i + 1 }}
          </div>
          <div class="row no-gutters">
            <div class="col-12 d-flex">
              <div class="media mg-l-10">
                <div class="avatar">
                  <img :src="l.startUser.avator" class="rounded" />
                </div>
              </div>
              <div class="activity-body mg-l-5">
                <p class="mg-b-2">
                  <strong>{{ l.startUser.fullName }}</strong>
                  <feather class="wd-16 ht-16" type="activity"></feather>
                  <template
                    v-if="
                      l.transferUser != null &&
                        l.transferUser.userId != l.startUser.userId
                    "
                  >
                    <strong class="link-02">{{
                      l.transferUser.fullName
                    }}</strong
                    >-д/т
                  </template>
                  <template
                    v-else-if="
                      l.transferUser != null &&
                        l.transferUser.userId == l.startUser.userId
                    "
                  >
                    <strong class="link-02">өөртөө</strong> шилжүүлэв.
                  </template>
                  <template v-else-if="l.transferUser == null">
                    <strong class="link-02">{{ l.usersCount }}</strong> хүнд
                    шилжүүлэв.
                  </template>
                </p>
                <div v-if="l.from != null" class="text-muted">
                  {{ l.from }}
                  <feather class="wd-16 ht-16" type="chevron-right"></feather>
                  {{ l.to }}
                </div>
                <div v-else>{{ l.to }}</div>
                <small class="tx-color-03">{{
                  l.date | moment("dddd, YYYY.MM.DD HH:mm")
                }}</small>
              </div>
              <div class="mg-l-auto d-none">
                <div v-if="l.isProjectChanged">
                  Ажил хэрэг солигдсон
                  <!-- <div>
                    <div>
                      <div>{{l.fromProjectName}} -н</div>
                      {{l.from}}
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                    <div>
                      <div>{{l.toProjectName}} -н</div>
                      {{l.to}}
                    </div>
                  </div> -->
                </div>
                <div v-else class="text-right">
                  <div class="tx-thin">
                    {{ l.toProjectName }}
                  </div>
                  <span v-if="l.from != null" class="text-muted">
                    {{ l.from }}
                    <feather
                      class="wd-16 ht-16"
                      type="chevrons-right"
                    ></feather>
                    {{ l.to }}
                  </span>
                  <span v-else>{{ l.to }}</span>
                </div>
              </div>
            </div>
            <div class="col-12" v-if="l.flag == 0">
              <div class="mg-t-5 pd-5 bg-light">
                <b class="link-03">Буцаасан тайлбар:</b> {{ l.execution }}
              </div>
            </div>
            <div
              class="col-12"
              v-else-if="l.execution != null && l.execution != ''"
            >
              <div class="mg-t-5 pd-5 bd-t bg-light">
                <b class="link-03">Тайлбар: </b>{{ l.execution }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </b-overlay>
  </div>
</template>

<script>
import { getTransferLogByTaskId } from "@/api/column";
import { mapActions } from "vuex";
var _ = require("lodash");

export default {
  props: {
    task: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      executionCount: -1,
      resObj: {
        loaded: false,
        list: []
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["handleLoading"]),
    init() {
      //console.log('transfers inited');
      this.handleLoading({ isLoading: true });

      getTransferLogByTaskId({
        params: { taskId: this.task.id, page: 0, size: 20 },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.resObj.loaded = true;
          this.resObj.list = _.orderBy(res.data.logs, "id", "asc");
          this.$emit("on-transfers-loaded", this.resObj.list);
          //console.log(res);
        }
      });
    }
  }
};
</script>
